import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation, Mousewheel, EffectFade } from 'swiper/modules';

export class TabsSlider extends AbstractComponent {
  init() {
    const slider = this.el.querySelector('.swiper');
    const labels = slider.dataset.labels.split(',');

    const activeIndex = this.options.activeIndex || 'first';

    const initialSlide = activeIndex === 'last' ? labels.length - 1 : 0;

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      speed: 700,
      effect: 'fade',
      initialSlide: initialSlide,
      fadeEffect: {
        crossFade: true,
      },
      modules: [Pagination, Autoplay, Mousewheel, EffectFade],
      // autoplay: {
      //   delay: 3000,
      //   // disableOnInteraction: true
      // },
      pagination: {
        clickable: true,
        el: '.block-tabs-slider__slider-pagination',
        bulletClass: 'block-tabs-slider__slider-pagination-bullet',
        bulletActiveClass: 'is-active',
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + labels[index] + "</span>";
        },
      },
    });

    swiper.on("autoplayTimeLeft", (swiper, timeLeft, percentage) => {
      slider.style.setProperty("--progress", 1 - percentage);
    });
  }
}

register('tabs-slider', TabsSlider);
